import React, { useState, useEffect } from 'react';

const EditOrgModal = ({ org, onSave, onClose, isAdmin }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [No_Forms, setNo_Forms] = useState('');

  useEffect(() => {
    if (org) {
      setName(org.name);
      setDescription(org.description);
      setNo_Forms(org.No_Forms);
    }
  }, [org]);

  const handleSubmit = e => {
    e.preventDefault();
    onSave({
      ...org,
      name,
      description,
      No_Forms,
    });
  };

  return (
    <dialog id="edit_modal" className="modal">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Editar Organización</h3>
        <form onSubmit={handleSubmit}>
          <br />
          <label className="input input-bordered flex items-center gap-2">
            <input
              type="text"
              className="grow"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Nombre de la Organización"
              required
            />
          </label>
          <br />
          <label className="input input-bordered flex items-center gap-2">
            <input
              type="text"
              className="grow"
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Descripción"
              required
            />
          </label>
          <br />
          <select
            className="select select-bordered w-full max-w-xs"
            value={No_Forms}
            onChange={e => setNo_Forms(e.target.value)}
            required
          >
            <option value="">Seleccione un limite de Formularios</option>
            <option value="10">De 1 a 10</option>
            <option value="20">De 1 a 20</option>
            <option value="30">De 1 a 30</option>
            <option value="40">De 1 a 40</option>
            <option value="50">De 1 a 50</option>
            <option value="60">De 1 a 60</option>
            <option value="70">De 1 a 70</option>
            <option value="80">De 1 a 80</option>
            <option value="90">De 1 a 90</option>
            <option value="100">De 1 a 100</option>
          </select>
          <br />
          <br />
          <button
            type="submit"
            className="btn btn-accent btn-outline rounded-full"
          >
            Guardar Cambios
          </button>
        </form>
        <div className="modal-action">
          <button
            className="btn btn-error btn-outline rounded-full"
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default EditOrgModal;
